ScoreTrekBattle.Favorite = ScoreTrekBattle.Favorite || {};

ScoreTrekBattle.Favorite.List = (function() {
    var _this, CONFIG, STATUS, CACHE;

    CONFIG = {
        CACHE_SIZE: 3,
        TYPES: {
            matchday: {
                tab: 'matchdays',
                listClass: 'tournament-list'
            },
            club: {
                tab: 'clubs',
                listClass: 'tournament-preset-list'
            },
            series: {
                tab: 'series',
                listClass: 'tournament-preset-list series-list'
            }
        }
    };

    CACHE = ListState.create(CONFIG.CACHE_SIZE);

    function resetStatus() {
        STATUS = {
            active: false,
            type: null,
            $view: null,
            $list: null,
            isShown: false,
            renderId: 0,
            CURRENT: null
        };
    }
    resetStatus();

    function onViewRender(type) {
        return new Promise(function(resolve) {
            STATUS.type = type;

            ScoreTrekBattle.View.updateMenu('/tournament/my');
            ScoreTrekBattle.Template.renderMulti([
                'tournament/nav/tabsFavorites',
                'favorite/list'
            ], {
                'favorite/list': {
                    type: type,
                    listClass: CONFIG.TYPES[type].listClass
                }
            }).then(views => {
                let $tabs;

                STATUS.active = true;
                STATUS.$view = views['favorite/list'].$view;
                STATUS.$list = STATUS.$view.find('[data-id="list"]');

                $tabs = views['tournament/nav/tabsFavorites'].$view;
                $tabs.find(`[data-tab="${CONFIG.TYPES[type].tab}"]`).addClass('isActive');

                resolve($tabs.add(STATUS.$view));
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;
            updateList();
            resolve();
        });
    }

    function onViewUpdate() {
        return new Promise(function(resolve) {
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            if (STATUS.CURRENT) {
                STATUS.CURRENT.scrollTop = AnimationHandler.getScrollTop();
            }

            resetStatus();
            resolve();
        });
    }

    function updateList() {
        let type, cacheItem, hasCache, loadingId;

        type = STATUS.type;
        cacheItem = CACHE.get(type);
        STATUS.CURRENT = cacheItem;
        hasCache = Array.isArray(cacheItem.items);
        loadingId = 'Favorite.List.updateList';

        if (hasCache) {
            showItems(type, cacheItem.items, cacheItem.scrollTop);
        } else {
            STATUS.$list.addClass('loading');
        }

        ScoreTrekBattle.View[hasCache ? 'loadingBackground' : 'loading'](loadingId, true);

        Api.request('/battle/favorite/list', {
            type: type
        }).then(result => {
            let items;

            items = result.list || [];

            if (!STATUS.$list || (STATUS.type !== type)) {
                return;
            }

            if (hasCache && ListState.isEqual(items, cacheItem.items)) {
                return;
            }

            cacheItem.items = items;

            return showItems(type, items, cacheItem.scrollTop);
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            if (STATUS.$list) {
                STATUS.$list.removeClass('loading');
            }
            ScoreTrekBattle.View[hasCache ? 'loadingBackground' : 'loading'](loadingId, false);
        });
    }

    function showItems(type, items, scrollTop) {
        let renderId;

        renderId = ++STATUS.renderId;

        return renderList(type, items).then($items => {
            if (!STATUS.$list || (STATUS.type !== type) || (renderId !== STATUS.renderId)) {
                return;
            }

            STATUS.$list.empty().append($items);

            if (!STATUS.isShown) {
                STATUS.isShown = true;
                ListState.restoreScrollTop(STATUS.$view, scrollTop);
            }
        });
    }

    function renderList(type, items) {
        if (items.length === 0) {
            return renderEmptyItem(type);
        }

        if (type === 'matchday') {
            return ScoreTrekBattle.League.Matchdays.renderList(items);
        }

        if (type === 'series') {
            return Promise.all(items.map(item => {
                return ScoreTrekBattle.Tournament.Series.List.renderItem(item);
            }));
        }

        return Promise.all(items.map(item => {
            return renderClubItem(item);
        }));
    }

    function renderClubItem(club) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('club/listItem', {club: club}, true).then(itemView => {
                resolve(itemView.$view);
            });
        });
    }

    function renderEmptyItem(type) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('favorite/listItemEmpty', {type: type}, true).then(itemView => {
                resolve([itemView.$view]);
            });
        });
    }

    _this = {};

    ScoreTrekBattle.View.register('/tournament/my/matchdays', () => { return onViewRender('matchday'); }, onViewLoad, onViewUpdate, onViewUnload);
    ScoreTrekBattle.View.register('/tournament/my/clubs', () => { return onViewRender('club'); }, onViewLoad, onViewUpdate, onViewUnload);
    ScoreTrekBattle.View.register('/tournament/my/series', () => { return onViewRender('series'); }, onViewLoad, onViewUpdate, onViewUnload);

    return _this;
})();
